<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(clickAdd)">
        <div class="form-row">
          <div class="form-group col-md-12">
            <ValidationProvider
              class="w-100"
              v-slot="{ errors }"
              rules="required"
            >
              <select
                class="form-control"
                style="flex: 1; min-width: 1px"
                v-model="dialectValue"
              >
                <option :value="null" disabled>請選擇方言</option>
                <option
                  v-for="item in dialectList"
                  :key="item.Guid"
                  :value="item"
                >
                  {{ item.Name }}
                </option>
              </select>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
          <div v-if="otherDialect" class="form-group col-md-12">
            <ValidationProvider
              class="w-100"
              v-slot="{ errors }"
              rules="required"
            >
              <input
                type="text"
                class="form-control"
                maxlength="200"
                placeholder="請填寫方言名稱"
                v-model.trim="local.DialectDescription"
              />
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
          <div class="form-group col-md-12">
            <ValidationProvider
              class="w-100"
              v-slot="{ errors }"
              rules="required"
            >
              <label for="" class="col-form-label" style="margin-right: 5px">
                程度
              </label>
              <select
                class="form-control"
                v-model="local.Degree"
                style="flex: 1; min-width: 1px"
              >
                <option :value="null" disabled>請選擇</option>
                <option
                  v-for="item in degreeList"
                  :key="item.Guid"
                  :value="item"
                >
                  {{ item.Name }}
                </option>
              </select>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="form-row">
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            style="margin-left: 6px; margin-right: 10px"
            @click="clickCancel"
          >
            取消
          </button>
          <button type="submit" class="btn btn-primary btn-sm">儲存</button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
export default {
  props: ["disabled"],
  name: "AddDialect",
  data() {
    return {
      type: "Dialect",

      dialectList: [],
      dialectValue: null,
      otherDialect: null,

      // 程度
      degreeList: [],

      local: {
        DialectGuid: null,
        Dialect: null,
        DegreeGuid: null,
        Degree: null,
        DialectDescription: null,
      },
    };
  },
  methods: {
    clickCancel() {
      this.$emit("addCancel");
    },
    clickAdd() {
      this.local.DegreeGuid = this.local.Degree.Guid;
      this.local.Degree = this.local.Degree.Name;
      this.$emit("addDialect", this.local, this.type);
    },
  },

  watch: {
    dialectValue: function (newVal) {
      if (newVal.Code === "other") {
        this.otherDialect = true;
      } else {
        this.otherDialect = false;
        this.local.DialectDescription = null;
      }
      if (typeof newVal === "object") {
        this.local.DialectGuid = newVal.Guid;
        this.local.Dialect = newVal.Name;
      }
    },
  },

  created() {
    // 取得方言
    this.get_dialect().then((result) => {
      this.dialectList = result;
    });

    // 取得程度
    this.get_language_degree().then((result) => {
      this.degreeList = result;
    });
  },
};
</script>

<style scoped lang="scss">
.btn-primary {
  &:disabled {
    background-color: #eee;
    border-color: #eee;
    color: black;
    cursor: auto;
  }
}
</style>
